import { UseQueryOptions } from '@tanstack/react-query';

import { LandingPage as LandingPageResponse } from 'domains/content/types';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths, BeeConfigType } from 'models/enums';
import { PathWithID } from 'models/types';

import QueryKeys from './keys';

// The API will return a Landing Page for saved templates or an object (with the footer pushed to object.page.rows[]) for the default.
type LandingPage = object | LandingPageResponse;

type UseLandingPageParams = {
    landingPageId: string;
    type?: BeeConfigType;
    reactQueryOptions?: UseQueryOptions<LandingPage, Error>;
};

const useLandingPage = ({ landingPageId, type = BeeConfigType.PAGE, reactQueryOptions }: UseLandingPageParams) =>
    useQuery<LandingPage>(
        QueryKeys.LANDING_PAGE_ID(landingPageId),
        `${
            new PathWithID(
                CuredApiPaths.LANDING_PAGES,
                landingPageId === 'default' ? landingPageId : Number(landingPageId)
            ).url
        }?type=${type}`,
        reactQueryOptions
    );

export default useLandingPage;
